// Shared background for the signed-out pages (Login, VerifyEmail, ResetPassword).
//
// These used to load /img/login-bg.jpg, which was lost with the Emergent CDN.
// Nothing broke loudly: Cloudflare's SPA rewrite answers any unknown path with
// index.html and a 200, so the browser asked for a photograph, received HTML,
// and rendered nothing. No 404, no console error — just a flat grey sign-in
// page that looked like a styling bug rather than a missing file.
//
// A gradient cannot go missing. To use a photograph again, drop it in
// frontend/public/img/ and set AUTH_BG_IMAGE to its path; it layers on top and
// the gradient stays underneath, so a future lost asset degrades to this
// instead of to nothing.

export const AUTH_BG_IMAGE = ""; // e.g. "/img/login-bg.jpg"

// Warm lamplight from the upper right, cooler ink below — a lit desk at night,
// dark enough for the white copy and its overlays to stay legible.
const GRADIENT = [
    "radial-gradient(115% 85% at 80% 10%, rgba(184,154,112,0.26) 0%, rgba(0,0,0,0) 55%)",
    "radial-gradient(95% 75% at 10% 90%, rgba(86,96,140,0.22) 0%, rgba(0,0,0,0) 62%)",
    "linear-gradient(150deg, #14151b 0%, #1c1d27 45%, #0d0e12 100%)",
].join(", ");

export const authBackgroundStyle = {
    backgroundImage: AUTH_BG_IMAGE ? `url(${AUTH_BG_IMAGE}), ${GRADIENT}` : GRADIENT,
    backgroundSize: "cover",
    backgroundPosition: "center",
};
